import type { I18nFn } from '#/i18n/types/I18nFn';

export enum PaymentLevel {
  HOURLY = 'HOURLY',
  SALARY = 'SALARY',
  STIPEND = 'STIPEND',
}

export function PAYMENT_LEVELS(i18n: I18nFn) {
  return {
    HOURLY: i18n('Hourly'),
    SALARY: i18n('Salary'),
    STIPEND: i18n('Stipend'),
  } satisfies Record<PaymentLevel, string>;
}

export function PAYMENT_LEVEL_RADIO_OR_SELECT_OPTIONS(i18n: I18nFn) {
  return Object.entries(PAYMENT_LEVELS(i18n))
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      value: key as keyof typeof PAYMENT_LEVELS,
      label: value,
    }));
}

export function PAYMENT_LEVEL_CHECKBOX_OPTIONS(i18n: I18nFn) {
  return Object.entries(PAYMENT_LEVELS(i18n))
    .sort(([, a], [, b]) => a.localeCompare(b))
    .map(([key, value]) => ({
      name: key as keyof typeof PAYMENT_LEVELS,
      label: value,
    }));
}
